import React, { useContext, useEffect, useState } from "react";
import { FaExclamationCircle } from "react-icons/fa";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../../Localization/LanguageContext";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../Components/Button";
import useSaifFetch from "../../../hooks/useSaifFetch";
import { API_ACTION, SaifFetch } from "../../../Utils/SaifFetch";
import { LoadingSpinner } from "@saif/loading-spinner";

//TODO: Remove this page when updating app. This functionality is handled in user management now. The flags/globes in images should also be removed when the file paths are updated for Mosaic.

const Approve = () => {
  const [actionTaken, setActionTaken] = useState(false);
  const [invite_valid, setInviteValid] = useState(false);
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  const { key } = useParams();
  let navigator = useNavigate();

  const [body, setBody] = useState({});
  const [shouldCallValidate, callValidate] = useState({});

  const { loading, status } = useSaifFetch<any>(
    API_ACTION.Pending_Steward + "?id=" + key + "&action=deny",
    body,
    SaifFetch.post
  );

  const {
    data: key_data,
    loading: key_loading,
    status: key_status,
    error: key_error,
  } = useSaifFetch<any>(
    API_ACTION.Steward_Action_Eligible + "?id=" + key,
    shouldCallValidate,
    SaifFetch.get
  );

  const OnApprove = () => {
    setBody({ default: true });
  };

  const OnCancel = () => {
    setActionTaken(true);
  };

  useEffect(() => {
    callValidate({ default: true });
  }, []);

  useEffect(() => {
    if (status === 200) {
      setActionTaken(true);
    } else if (status && status >= 400) {
      navigator("/error");
    }
  }, [status]);

  useEffect(() => {
    if (key_status === 200) {
      console.log("200 back");
      setInviteValid(true);
    } else if (key_status && key_status >= 400) {
      navigator("/notfound");
    }
  }, [key_status]);

  return (
    <div className="body">
      {key_loading && (
        <LoadingSpinner
          className="loading"
          text={getValue("Deny", "Loading")}
        />
      )}
      {invite_valid && (
        <div className="body-content">
          {loading && (
            <LoadingSpinner
              className="loading"
              text={getValue("Deny", "Loading")}
            />
          )}
          {actionTaken ? (
            <div className="font-header-regular text-evergreen text-4xl mb-3">
              {getValue("Deny", "Done")}
            </div>
          ) : (
            <>
              <h1>
                <FaExclamationCircle className="font-header-thin text-evergreen text-6xl mb-3" />
              </h1>
              <div className="font-header-regular text-evergreen text-3xl mb-3">
                {getValue("Deny", "Prompt")}
              </div>
              <div className="row d-flex align-items-center justify-content-center gap-3">
                <Button bootstrap="col-auto" onClick={() => OnApprove()}>
                  {getValue("Deny", "Approve")}
                </Button>
                <Button
                  bootstrap="col-auto"
                  onClick={() => OnCancel()}
                  version="secondary"
                >
                  {getValue("Deny", "Cancel")}
                </Button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Approve;
